import ScrollReveal from 'scrollreveal';

const sr =  ScrollReveal();

export default sr;
